import { createClient } from '@blinkdotnew/sdk';

const blink = createClient({
  projectId: 'lemon-ui-agentic-email-ai-agent-ben3ou87',
});

/**
 * Demo data service - DEPRECATED
 * Demo data functionality has been removed to ensure clean production experience
 */
export const demoDataService = {
  /**
   * Generate realistic demo emails (1000 emails)
   */
  generateDemoEmails(userId: string) {
    const contacts = [
      { email: 'sarah.johnson@techcorp.com', name: 'Sarah Johnson', company: 'TechCorp', role: 'CEO' },
      { email: 'michael.chen@innovate.io', name: 'Michael Chen', company: 'Innovate.io', role: 'CTO' },
      { email: 'emma.williams@startup.co', name: 'Emma Williams', company: 'Startup Co', role: 'Product Manager' },
      { email: 'david.brown@enterprise.com', name: 'David Brown', company: 'Enterprise Inc', role: 'VP Sales' },
      { email: 'olivia.davis@agency.io', name: 'Olivia Davis', company: 'Agency.io', role: 'Creative Director' },
      { email: 'james.miller@consulting.com', name: 'James Miller', company: 'Consulting Co', role: 'Senior Consultant' },
      { email: 'sophia.garcia@marketing.pro', name: 'Sophia Garcia', company: 'Marketing Pro', role: 'CMO' },
      { email: 'william.martinez@finance.net', name: 'William Martinez', company: 'Finance Net', role: 'CFO' },
      { email: 'isabella.rodriguez@design.studio', name: 'Isabella Rodriguez', company: 'Design Studio', role: 'Lead Designer' },
      { email: 'alexander.lee@development.dev', name: 'Alexander Lee', company: 'Development Co', role: 'Engineering Manager' },
    ];

    const subjects = [
      'Q4 Strategy Meeting',
      'Project Update - Phase 2',
      'Budget Review Required',
      'Partnership Proposal',
      'Weekly Team Sync',
      'Client Feedback Discussion',
      'Product Launch Timeline',
      'Contract Negotiation',
      'Urgent: Server Issues',
      'Monthly Performance Review',
      'Design Review Session',
      'Code Review Request',
      'Marketing Campaign Analysis',
      'Quarterly Business Review',
      'Team Building Event',
    ];

    const bodyTemplates = [
      (name: string) => `<!DOCTYPE html>
<html>
<head>
  <style>
    body { font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif; color: #333; line-height: 1.6; }
    .container { max-width: 600px; margin: 0 auto; padding: 20px; }
    .header { background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); color: white; padding: 30px; border-radius: 8px 8px 0 0; }
    .content { background: white; padding: 30px; border: 1px solid #e5e7eb; border-top: none; border-radius: 0 0 8px 8px; }
    .footer { text-align: center; padding: 20px; color: #6b7280; font-size: 12px; }
    .button { display: inline-block; background: #667eea; color: white; padding: 12px 24px; text-decoration: none; border-radius: 6px; margin: 10px 0; }
    .highlight { background: #fef3c7; padding: 2px 6px; border-radius: 3px; }
    ul { padding-left: 20px; }
    li { margin: 8px 0; }
  </style>
</head>
<body>
  <div class="container">
    <div class="header">
      <h1 style="margin: 0; font-size: 24px;">Project Follow-Up</h1>
      <p style="margin: 10px 0 0 0; opacity: 0.9;">Quick Update & Next Steps</p>
    </div>
    <div class="content">
      <p>Hi there,</p>
      <p>Just wanted to follow up on our conversation from earlier. Could you please review the attached documents and let me know your thoughts?</p>
      <p><strong>Key Points to Review:</strong></p>
      <ul>
        <li>Updated project timeline</li>
        <li>Budget allocation breakdown</li>
        <li>Resource requirements</li>
      </ul>
      <p>I've highlighted the <span class="highlight">most critical sections</span> that need your immediate attention.</p>
      <a href="#" class="button">View Documents</a>
      <p>Looking forward to your feedback.</p>
      <p>Best regards,<br/><strong>${name}</strong></p>
    </div>
    <div class="footer">
      This email was sent from our automated system. Please do not reply directly.
    </div>
  </div>
</body>
</html>`,
      (name: string) => `<!DOCTYPE html>
<html>
<head>
  <style>
    body { font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; color: #1f2937; line-height: 1.7; background: #f9fafb; }
    .container { max-width: 650px; margin: 0 auto; background: white; }
    .header { background: #0ea5e9; color: white; padding: 40px 30px; text-align: center; }
    .content { padding: 40px 30px; }
    .info-box { background: #f0f9ff; border-left: 4px solid #0ea5e9; padding: 15px; margin: 20px 0; }
    .calendar-icon { display: inline-block; width: 40px; height: 40px; background: #0ea5e9; color: white; text-align: center; line-height: 40px; border-radius: 8px; font-weight: bold; margin-right: 10px; }
    .action-items { background: #f3f4f6; padding: 20px; border-radius: 8px; margin: 20px 0; }
    .footer { background: #f9fafb; padding: 30px; text-align: center; color: #6b7280; border-top: 1px solid #e5e7eb; }
  </style>
</head>
<body>
  <div class="container">
    <div class="header">
      <h1 style="margin: 0; font-size: 28px;">📅 Project Timeline Discussion</h1>
    </div>
    <div class="content">
      <p>Hello,</p>
      <p>I hope this email finds you well. I wanted to discuss the upcoming project timeline and ensure we're aligned on deliverables.</p>
      <div class="info-box">
        <strong>📌 Meeting Request:</strong> Could we schedule a quick 30-minute call this week?
      </div>
      <div class="action-items">
        <h3 style="margin-top: 0;">Discussion Topics:</h3>
        <ul style="margin-bottom: 0;">
          <li><strong>Phase 1:</strong> Initial requirements gathering (Weeks 1-2)</li>
          <li><strong>Phase 2:</strong> Design & prototyping (Weeks 3-5)</li>
          <li><strong>Phase 3:</strong> Development & testing (Weeks 6-10)</li>
          <li><strong>Phase 4:</strong> Launch & support (Week 11+)</li>
        </ul>
      </div>
      <p>Please let me know your availability for this week, and I'll send a calendar invite.</p>
      <p>Thanks,<br/><strong>${name}</strong></p>
    </div>
    <div class="footer">
      <p style="margin: 0;">Sent from Project Management System</p>
    </div>
  </div>
</body>
</html>`,
      (name: string) => `<!DOCTYPE html>
<html>
<head>
  <style>
    body { font-family: 'Helvetica Neue', Arial, sans-serif; color: #374151; background: #ffffff; line-height: 1.6; }
    .email-container { max-width: 600px; margin: 20px auto; border: 1px solid #e5e7eb; border-radius: 12px; overflow: hidden; box-shadow: 0 4px 6px rgba(0,0,0,0.05); }
    .email-header { background: linear-gradient(to right, #10b981, #059669); color: white; padding: 25px; }
    .email-body { padding: 30px; background: white; }
    .tag { display: inline-block; background: #d1fae5; color: #065f46; padding: 4px 12px; border-radius: 12px; font-size: 12px; font-weight: 600; margin: 0 5px 5px 0; }
    .status-card { background: #f9fafb; border: 2px solid #d1d5db; padding: 20px; border-radius: 8px; margin: 15px 0; }
    .checkmark { color: #10b981; font-size: 20px; margin-right: 8px; }
    table { width: 100%; border-collapse: collapse; margin: 15px 0; }
    td { padding: 10px; border-bottom: 1px solid #e5e7eb; }
    .footer { background: #f9fafb; padding: 20px; text-align: center; font-size: 13px; color: #9ca3af; }
  </style>
</head>
<body>
  <div class="email-container">
    <div class="email-header">
      <h2 style="margin: 0; font-size: 22px;">✅ Proposal Review Request</h2>
    </div>
    <div class="email-body">
      <p>Hi there,</p>
      <p>Thank you for the detailed update. I've reviewed the proposal and have a few questions.</p>
      <div class="status-card">
        <p style="margin: 0 0 10px 0;"><strong>Current Status:</strong></p>
        <p style="margin: 5px 0;"><span class="checkmark">✓</span> Initial review completed</p>
        <p style="margin: 5px 0;"><span class="checkmark">✓</span> Technical feasibility assessed</p>
        <p style="margin: 5px 0;"><span class="checkmark">✓</span> Budget considerations noted</p>
      </div>
      <p><strong>Questions to Discuss:</strong></p>
      <table>
        <tr><td><strong>1.</strong></td><td>Timeline flexibility for Phase 2</td></tr>
        <tr><td><strong>2.</strong></td><td>Resource allocation concerns</td></tr>
        <tr><td><strong>3.</strong></td><td>Risk mitigation strategies</td></tr>
        <tr><td><strong>4.</strong></td><td>Stakeholder communication plan</td></tr>
      </table>
      <p>Can we set up a meeting to go through these points in detail?</p>
      <div style="margin: 20px 0;">
        <span class="tag">High Priority</span>
        <span class="tag">Requires Action</span>
        <span class="tag">Meeting Needed</span>
      </div>
      <p>Appreciate your time.</p>
      <p>Regards,<br/><strong>${name}</strong></p>
    </div>
    <div class="footer">
      This is an automated notification | Do not reply to this email
    </div>
  </div>
</body>
</html>`,
      (name: string) => `<!DOCTYPE html>
<html>
<head>
  <style>
    body { font-family: system-ui, -apple-system, sans-serif; color: #111827; background: #fafafa; line-height: 1.7; }
    .wrapper { max-width: 680px; margin: 30px auto; background: white; border-radius: 16px; overflow: hidden; box-shadow: 0 10px 25px rgba(0,0,0,0.08); }
    .banner { background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%); padding: 50px 40px; text-align: center; color: white; }
    .banner h1 { margin: 0; font-size: 32px; font-weight: 700; }
    .banner p { margin: 10px 0 0 0; font-size: 16px; opacity: 0.95; }
    .main-content { padding: 40px; }
    .progress-bar { background: #f3f4f6; height: 8px; border-radius: 4px; overflow: hidden; margin: 20px 0; }
    .progress-fill { background: linear-gradient(to right, #f59e0b, #d97706); height: 100%; width: 75%; }
    .metric-card { display: inline-block; background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%); padding: 20px; border-radius: 12px; margin: 10px 10px 10px 0; min-width: 150px; }
    .metric-number { font-size: 36px; font-weight: 700; color: #92400e; margin: 0; }
    .metric-label { color: #78350f; font-size: 14px; margin: 5px 0 0 0; }
    .cta-button { display: inline-block; background: #f59e0b; color: white; padding: 14px 32px; text-decoration: none; border-radius: 8px; font-weight: 600; margin: 20px 0; box-shadow: 0 4px 12px rgba(245,158,11,0.3); }
    .divider { height: 1px; background: linear-gradient(to right, transparent, #e5e7eb, transparent); margin: 30px 0; }
  </style>
</head>
<body>
  <div class="wrapper">
    <div class="banner">
      <h1>🎉 Exciting Progress Update!</h1>
      <p>We're crushing our goals together</p>
    </div>
    <div class="main-content">
      <p>Good morning,</p>
      <p>I wanted to share some exciting news about our recent progress. The team has been working diligently and <strong>we're ahead of schedule!</strong></p>
      <div class="progress-bar">
        <div class="progress-fill"></div>
      </div>
      <p style="text-align: center; color: #6b7280; margin: 5px 0 25px 0;">75% Complete - On Track for Early Delivery</p>
      <div style="text-align: center;">
        <div class="metric-card">
          <p class="metric-number">12</p>
          <p class="metric-label">Tasks Completed</p>
        </div>
        <div class="metric-card">
          <p class="metric-number">3</p>
          <p class="metric-label">Weeks Ahead</p>
        </div>
        <div class="metric-card">
          <p class="metric-number">98%</p>
          <p class="metric-label">Quality Score</p>
        </div>
      </div>
      <div class="divider"></div>
      <p><strong>Recent Achievements:</strong></p>
      <ul style="color: #4b5563;">
        <li>✨ Completed core feature development</li>
        <li>🚀 Deployed to staging environment</li>
        <li>🎯 Exceeded performance benchmarks</li>
        <li>👥 Positive feedback from beta testers</li>
      </ul>
      <p>Let's connect soon to discuss next steps and celebrate this milestone!</p>
      <div style="text-align: center;">
        <a href="#" class="cta-button">Schedule Celebration Call</a>
      </div>
      <p>Best,<br/><strong>${name}</strong></p>
    </div>
    <div style="background: #f9fafb; padding: 25px; text-align: center; color: #9ca3af; font-size: 13px;">
      <p style="margin: 0;">Keep up the amazing work! 💪</p>
    </div>
  </div>
</body>
</html>`,
    ];

    const emails = [];
    const now = new Date();

    for (let i = 0; i < 1000; i++) {
      const contact = contacts[Math.floor(Math.random() * contacts.length)];
      const subject = subjects[Math.floor(Math.random() * subjects.length)];
      const bodyTemplate = bodyTemplates[Math.floor(Math.random() * bodyTemplates.length)];
      const direction = Math.random() > 0.5 ? 'received' : 'sent';
      const isUrgent = Math.random() > 0.85 ? '1' : '0';
      const hasResponse = Math.random() > 0.3 ? '1' : '0';
      
      // Create realistic timestamps over the past 90 days
      const daysAgo = Math.floor(Math.random() * 90);
      const hoursAgo = Math.floor(Math.random() * 24);
      const sentAt = new Date(now);
      sentAt.setDate(sentAt.getDate() - daysAgo);
      sentAt.setHours(sentAt.getHours() - hoursAgo);

      const htmlBody = bodyTemplate(contact.name);
      
      emails.push({
        id: `email_${i + 1}`,
        userId,
        contactEmail: contact.email,
        subject: `${subject} - ${i + 1}`,
        body: htmlBody, // Store HTML directly
        direction,
        sentAt: sentAt.toISOString(),
        isUrgent,
        hasResponse,
        aiSummary: `Discussion about ${subject.toLowerCase()} with ${contact.name}`,
        keyPoints: JSON.stringify([
          'Action items identified',
          'Timeline discussed',
          'Next steps defined',
        ]),
        createdAt: sentAt.toISOString(),
      });
    }

    return emails;
  },

  /**
   * Generate demo contacts with intelligence
   */
  generateDemoContacts(userId: string) {
    const contactsData = [
      {
        email: 'sarah.johnson@techcorp.com',
        name: 'Sarah Johnson',
        company: 'TechCorp',
        relationshipType: 'Strategic Partner',
        relationshipStage: 'Established',
        relationshipHealth: 'Strong',
        engagementLevel: 'High',
        trustLevel: 'High',
        communicationStyle: 'Direct and concise',
        powerDynamic: 'Equal partnership',
        aiRelationshipScore: 95,
        totalInteractions: 145,
      },
      {
        email: 'michael.chen@innovate.io',
        name: 'Michael Chen',
        company: 'Innovate.io',
        relationshipType: 'Technical Collaborator',
        relationshipStage: 'Growing',
        relationshipHealth: 'Good',
        engagementLevel: 'Medium',
        trustLevel: 'Medium-High',
        communicationStyle: 'Technical and detailed',
        powerDynamic: 'Peer collaboration',
        aiRelationshipScore: 88,
        totalInteractions: 98,
      },
      {
        email: 'emma.williams@startup.co',
        name: 'Emma Williams',
        company: 'Startup Co',
        relationshipType: 'Client',
        relationshipStage: 'New',
        relationshipHealth: 'Developing',
        engagementLevel: 'High',
        trustLevel: 'Medium',
        communicationStyle: 'Enthusiastic and frequent',
        powerDynamic: 'Client-Vendor',
        aiRelationshipScore: 82,
        totalInteractions: 67,
      },
      {
        email: 'david.brown@enterprise.com',
        name: 'David Brown',
        company: 'Enterprise Inc',
        relationshipType: 'Prospect',
        relationshipStage: 'Negotiation',
        relationshipHealth: 'Positive',
        engagementLevel: 'Medium',
        trustLevel: 'Medium',
        communicationStyle: 'Formal and structured',
        powerDynamic: 'Decision maker',
        aiRelationshipScore: 75,
        totalInteractions: 42,
      },
      {
        email: 'olivia.davis@agency.io',
        name: 'Olivia Davis',
        company: 'Agency.io',
        relationshipType: 'Collaborator',
        relationshipStage: 'Established',
        relationshipHealth: 'Strong',
        engagementLevel: 'High',
        trustLevel: 'High',
        communicationStyle: 'Creative and visual',
        powerDynamic: 'Mutual respect',
        aiRelationshipScore: 91,
        totalInteractions: 112,
      },
      {
        email: 'james.miller@consulting.com',
        name: 'James Miller',
        company: 'Consulting Co',
        relationshipType: 'Advisor',
        relationshipStage: 'Established',
        relationshipHealth: 'Strong',
        engagementLevel: 'Low',
        trustLevel: 'High',
        communicationStyle: 'Strategic and thoughtful',
        powerDynamic: 'Mentor',
        aiRelationshipScore: 89,
        totalInteractions: 56,
      },
      {
        email: 'sophia.garcia@marketing.pro',
        name: 'Sophia Garcia',
        company: 'Marketing Pro',
        relationshipType: 'Partner',
        relationshipStage: 'Growing',
        relationshipHealth: 'Good',
        engagementLevel: 'Medium',
        trustLevel: 'Medium-High',
        communicationStyle: 'Data-driven and analytical',
        powerDynamic: 'Collaborative',
        aiRelationshipScore: 84,
        totalInteractions: 78,
      },
      {
        email: 'william.martinez@finance.net',
        name: 'William Martinez',
        company: 'Finance Net',
        relationshipType: 'Stakeholder',
        relationshipStage: 'Established',
        relationshipHealth: 'Professional',
        engagementLevel: 'Low',
        trustLevel: 'Medium',
        communicationStyle: 'Numbers-focused',
        powerDynamic: 'Authority figure',
        aiRelationshipScore: 72,
        totalInteractions: 34,
      },
      {
        email: 'isabella.rodriguez@design.studio',
        name: 'Isabella Rodriguez',
        company: 'Design Studio',
        relationshipType: 'Service Provider',
        relationshipStage: 'Growing',
        relationshipHealth: 'Excellent',
        engagementLevel: 'High',
        trustLevel: 'High',
        communicationStyle: 'Visual and inspiring',
        powerDynamic: 'Expert consultant',
        aiRelationshipScore: 87,
        totalInteractions: 91,
      },
      {
        email: 'alexander.lee@development.dev',
        name: 'Alexander Lee',
        company: 'Development Co',
        relationshipType: 'Technical Lead',
        relationshipStage: 'Established',
        relationshipHealth: 'Strong',
        engagementLevel: 'High',
        trustLevel: 'High',
        communicationStyle: 'Problem-solving focused',
        powerDynamic: 'Technical authority',
        aiRelationshipScore: 93,
        totalInteractions: 128,
      },
    ];

    return contactsData.map((contact, index) => ({
      id: `contact_${index + 1}`,
      userId,
      ...contact,
      lastInteractionAt: new Date(Date.now() - Math.random() * 7 * 24 * 60 * 60 * 1000).toISOString(),
      createdAt: new Date(Date.now() - 90 * 24 * 60 * 60 * 1000).toISOString(),
      updatedAt: new Date().toISOString(),
    }));
  },

  /**
   * Generate contact intelligence records
   */
  generateContactIntelligence(userId: string, contacts: any[]) {
    return contacts.map((contact, index) => ({
      id: `intel_${index + 1}`,
      contactId: contact.id,
      userId,
      analysisType: 'comprehensive',
      relationshipAnalysis: JSON.stringify({
        summary: `${contact.name} is a ${contact.relationshipType.toLowerCase()} with ${contact.relationshipStage.toLowerCase()} relationship stage`,
        keyInsights: [
          `Communication frequency: ${contact.engagementLevel}`,
          `Trust level: ${contact.trustLevel}`,
          `Health status: ${contact.relationshipHealth}`,
        ],
      }),
      communicationPatterns: JSON.stringify({
        preferredTimeOfDay: ['9:00 AM - 11:00 AM', '2:00 PM - 4:00 PM'],
        responseTime: Math.floor(Math.random() * 24) + 1,
        communicationFrequency: contact.engagementLevel,
        preferredChannels: ['Email', 'Video Call'],
      }),
      behavioralInsights: JSON.stringify({
        decisionMakingStyle: contact.communicationStyle,
        priorities: ['Results', 'Collaboration', 'Innovation'],
        workStyle: 'Organized and systematic',
      }),
      predictiveInsights: JSON.stringify({
        nextContactPrediction: new Date(Date.now() + Math.random() * 7 * 24 * 60 * 60 * 1000).toISOString(),
        engagementTrend: Math.random() > 0.5 ? 'Increasing' : 'Stable',
        relationshipTrajectory: 'Positive',
      }),
      actionRecommendations: JSON.stringify([
        `Schedule monthly check-in with ${contact.name}`,
        'Share relevant industry insights',
        'Acknowledge recent milestones',
      ]),
      timelineInsights: JSON.stringify({
        firstInteraction: new Date(Date.now() - 90 * 24 * 60 * 60 * 1000).toISOString(),
        lastInteraction: contact.lastInteractionAt,
        totalInteractions: contact.totalInteractions,
        interactionFrequency: 'Weekly',
      }),
      confidenceScore: Math.floor(Math.random() * 20) + 80,
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    }));
  },

  /**
   * Generate user model with comprehensive analysis
   */
  generateUserModel(userId: string) {
    return {
      id: `model_${Date.now()}`,
      userId,
      modelStatus: 'completed',
      confidenceScore: 92,
      totalEmailsAnalyzed: 1000,
      personalityTraits: JSON.stringify([
        'Strategic thinker',
        'Detail-oriented',
        'Collaborative',
        'Results-driven',
        'Excellent communicator',
      ]),
      workStyle: 'Organized and systematic with a focus on collaboration',
      communicationPreferences: JSON.stringify([
        'Clear and concise emails',
        'Scheduled meetings over ad-hoc calls',
        'Visual presentations for complex topics',
        'Bullet points over long paragraphs',
        'Proactive updates on progress',
      ]),
      priorities: JSON.stringify([
        'Team collaboration',
        'Project delivery',
        'Client satisfaction',
        'Innovation',
        'Work-life balance',
      ]),
      decisionMakingStyle: 'Data-driven with collaborative input',
      behavioralSummary: `Based on analysis of 1,000 emails, you demonstrate a highly organized and strategic work style. You prioritize clear communication and collaboration, with a strong focus on delivering results. Your emails show consistent professionalism, attention to detail, and a proactive approach to problem-solving. You tend to respond quickly to urgent matters (avg 2.3 hours) and maintain strong relationships with key stakeholders. Your communication peaks during morning hours (9-11 AM), and you prefer structured discussions with clear agendas. You demonstrate high emotional intelligence in written communication, adapting your tone based on the recipient and context.`,
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    };
  },

  /**
   * Generate email statistics
   */
  generateEmailStatistics(userId: string) {
    return {
      id: `stats_${Date.now()}`,
      userId,
      statDate: new Date().toISOString().split('T')[0],
      totalReceived: 612,
      totalSent: 388,
      totalUrgent: 47,
      avgResponseTimeHours: 2.3,
      topContacts: JSON.stringify([
        'sarah.johnson@techcorp.com',
        'alexander.lee@development.dev',
        'olivia.davis@agency.io',
        'michael.chen@innovate.io',
        'sophia.garcia@marketing.pro',
      ]),
      busiestHours: JSON.stringify(['9-11 AM', '2-4 PM', '7-8 PM']),
      communicationTrends: JSON.stringify({
        weeklyAverage: 142,
        responseRate: 0.89,
        urgentEmailRate: 0.047,
        peakDay: 'Tuesday',
        emailVolumeChange: '+12%',
      }),
      createdAt: new Date().toISOString(),
    };
  },

  /**
   * Seed demo data - DEPRECATED
   * This functionality has been removed
   */
  async seedDemoData(userId: string): Promise<{ success: boolean; message: string; stats?: any }> {
    return {
      success: false,
      message: 'Demo data functionality has been removed. Please connect your email accounts.',
    };
  },

  /**
   * Clear all demo data for user
   */
  async clearDemoData(userId: string): Promise<{ success: boolean; message: string }> {
    try {
      // Delete all user data
      const emails = await blink.db.emails.list({ where: { userId } });
      for (const email of emails) {
        await blink.db.emails.delete(email.id);
      }

      const contacts = await blink.db.contacts.list({ where: { userId } });
      for (const contact of contacts) {
        await blink.db.contacts.delete(contact.id);
      }

      const intelligence = await blink.db.contactIntelligence.list({ where: { userId } });
      for (const intel of intelligence) {
        await blink.db.contactIntelligence.delete(intel.id);
      }

      const models = await blink.db.userModels.list({ where: { userId } });
      for (const model of models) {
        await blink.db.userModels.delete(model.id);
      }

      const stats = await blink.db.emailStatistics.list({ where: { userId } });
      for (const stat of stats) {
        await blink.db.emailStatistics.delete(stat.id);
      }

      return {
        success: true,
        message: 'Demo data cleared successfully',
      };
    } catch (error) {
      console.error('Error clearing demo data:', error);
      return {
        success: false,
        message: error instanceof Error ? error.message : 'Failed to clear demo data',
      };
    }
  },
};
